export const ENVIRONMENT = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT;

export const TG_APP_URL =
  ENVIRONMENT === "prod"
    ? process.env.REACT_APP_TG_APP_URL_PROD
    : process.env.REACT_APP_TG_APP_URL_STAGING;

export const TG_PRIVATE_SALE = TG_APP_URL + "/private-sales";

export const SERVER_URL =
  ENVIRONMENT === "prod"
    ? process.env.REACT_APP_SERVER_URL_PROD
    : ENVIRONMENT === "staging"
    ? process.env.REACT_APP_SERVER_URL_STAGING
    : "http://localhost:3001";
